var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"placeholder"},[_c('h1',{staticClass:"placeholder__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"placeholder__text"},[_vm._v("Contenu à définir.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }